import baseAPI from "@/http";

const router = "api/territorios";

export const territorioAPI = {
  create: (city) => baseAPI.post(`${router}/cadastrar-territorios`, city),
  update: (city) => baseAPI.put(`${router}/editar-territorios`, city),
  delete: (id) => baseAPI.delete(`${router}/excluir-territorio?id=${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/obter-territorios-por-id/${id}`),
};
